import React, { Component, Fragment } from "react";
import {
  BarChart,
  Bar,
  Tooltip,
  ResponsiveContainer,
  YAxis,
  XAxis,
  Cell,
} from "recharts";

import {
  CustomizedXAxisTick,
  StandardTooltip,
  selectFormat,
  Error,
  MAIN_COLORS,
} from "components/Utils/Utils.js";

class MarqueeViewersViewTime extends Component {
  componentDidMount() {
    this.props.childRef(this);
  }

  getExportData = () => ({
    data: this.props.data.data,
    opts: {
      type: "chart",
      date: { name: "name", title: this.props.title, no_date: true },
      exclude: ["name"],
    },
  });

  getColor = (name) => {
    const index = this.props.data.data.findIndex((d) => d.name === name);
    return MAIN_COLORS[index % MAIN_COLORS.length];
  };

  render() {
    const { data, url } = this.props;

    if (data.hasData === false) {
      return <Error minHeight={360} />;
    }

    const isTime = url.includes("view_time");

    return (
      <ResponsiveContainer height={485}>
        <BarChart
          data={data.data}
          layout="vertical"
          margin={{ top: 10, right: 0, left: 0, bottom: 10 }}
        >
          <Tooltip
            cursor={{ fill: "#eee", opacity: 0.5 }}
            content={
              <StandardTooltip
                render={({ data }) => {
                  const payload = data(this.props);

                  if (payload !== null) {
                    return (
                      <div className="standard-tooltip">
                        {Object.keys(payload).map((key, i) => (
                          <Fragment key={key}>
                            <header className="standard-tooltip__header">
                              <span className="standard-tooltip__key-header">
                                {this.props.title}
                              </span>
                            </header>
                            <main className="standard-tooltip__main">
                              <div className="standard-tooltip__item">
                                <span className="standard-tooltip__key">
                                  <span
                                    className="standard-tooltip__icon"
                                    style={{
                                      background: this.getColor(
                                        payload[key].payload.name
                                      ),
                                    }}
                                  />
                                  {payload[key].payload.name}
                                </span>
                                <span className="standard-tooltip__value">
                                  {selectFormat(
                                    isTime ? "minutes" : "number",
                                    payload[key].value
                                  )}
                                </span>
                              </div>
                            </main>
                          </Fragment>
                        ))}
                      </div>
                    );
                  }
                }}
              />
            }
          />
          <XAxis
            type="number"
            axisLine={false}
            tickLine={false}
            mirror={false}
            dataKey="value"
            tick={<CustomizedXAxisTick />}
          />
          <YAxis
            type="category"
            axisLine={false}
            tickLine={false}
            mirror={false}
            dataKey="name"
          />
          <Bar dataKey="value">
            {data.data.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={this.getColor(entry.name)} />
            ))}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    );
  }
}

export default MarqueeViewersViewTime;
